import { CollectionViewer, ListRange } from '@angular/cdk/collections';
import { Observable } from 'rxjs';

export interface ElCollectionViewer extends CollectionViewer {
  viewChange: Observable<ListRange>;
}
